import { NgModule } from '@angular/core';

import { ButtonLoadingIndicatorComponent } from './button-loading-indicator.component';
import { GlxyButtonShowProgressDirective } from './button-show-progress.directive';
export { ButtonLoadingIndicatorComponent };
export { GlxyButtonShowProgressDirective };

@NgModule({
  imports: [ButtonLoadingIndicatorComponent, GlxyButtonShowProgressDirective],
  exports: [ButtonLoadingIndicatorComponent, GlxyButtonShowProgressDirective],
})
export class GalaxyButtonLoadingIndicatorModule {}
